// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"4ce70eb8","168":"8cfabf5a","232":"b0760296","265":"34f22867","289":"271ad2c2","312":"ef724407","320":"9699762e","407":"4710e518","453":"94c6780d","536":"b8f021a0","682":"1fd8daa3","969":"d9e69345"}[chunkId] + ".chunk.js";
};